<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 20 21"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M7.09644 1.81494C8.34961 0.844214 10.3345 0.736056 11.7234 1.52881L11.9929 1.69971L17.7537 5.72998C18.2227 6.05844 18.6665 6.59711 18.9939 7.22412C19.3213 7.8513 19.5095 8.52438 19.5095 9.1001V15.8804C19.5094 18.154 17.664 20.0003 15.3904 20.0005H4.61011C2.3378 20.0005 0.490219 18.1457 0.48999 15.8706V8.97021L0.497803 8.76514C0.534491 8.2765 0.697824 7.72084 0.95874 7.19092C1.21951 6.66134 1.56136 6.19017 1.92847 5.85791L2.08765 5.72412L7.09644 1.81494ZM9.99976 12.2505C9.31372 12.2506 8.74976 12.8144 8.74976 13.5005V16.5005C8.74992 17.1864 9.31382 17.7504 9.99976 17.7505C10.6858 17.7505 11.2496 17.1865 11.2498 16.5005V13.5005C11.2498 12.8143 10.6859 12.2505 9.99976 12.2505Z"
    [attr.fill]="color"
    stroke="black"
  />
</svg>
